<template>
  <div class="pc_scroll-tab">
    <!-- 头部导航 -->
    <PC-scroll ref="scroll" :data="list" :click="true" class="scroll">
      <ul class="activity-rule-nav">
        <template>
          <li
            v-for="(item, index) in list"
            :key="index"
            :class="[
              index == active || (item.brandId && activeId && activeId == item.brandId)
                ? 'active'
                : ''
            ]"
            @click="handleSetActive(item, index, $event)"
          >
            {{ item.tabName || item.name || item.categoryName || item.brandName }}
          </li>
        </template>
      </ul>
    </PC-scroll>
 
  </div>
</template>
<script>
import PCScroll from '../PCScroll';
export default {
  components: {
    PCScroll
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    // 默认是品牌id
    activeId: {
      type: Number || String,
      default: null
    },
    // 默认选中的id
    id: {
      type: Number || String,
      default: null
    }
  },
  data() {
    return {
      sortList: [],
      tabId: null
    };
  },
  watch: {

  },
  methods: {
    handleSetActive(item, index, event) {
      const data = {
        ...item,
        index
      };
      this.$emit('handleSetActive', data);
     
    },
    handleNoData(data) {
      setTimeout(() => {
        this.$emit('handleNoData', data);
      }, 100);
    },
    initResponse(data) {
      let sortList = [];
      data.forEach((val, index) => {
        if (val.body && val.body.textList) {
          data[index].body.textList = val.body.textList.map((sub, num) => {
            sub.body = sub.body.split('\n');
            return sub;
          });
        }
        // 重排序
        let arr = new Array(3);
        for (let key in val) {
          if (Object.prototype.toString.call(val[key]) === '[object Object]') {
            arr[parseInt(val[key].sort)] = val[key];
          }
        }
        sortList.push(arr);
      });
      // 已按 sort 排序
      this.sortList = sortList;
      this.list = data;
      // this.list = []
    },
    // 点击品牌后，根据品牌id查询获取品牌的产品列表
    queryProductById(id) {
      if (id) {
        id = parseInt(id);
        let num = 0;
        this.list.map(item => {
          if (item.brandId === id) {
            num++;
          }
        });
        if (num === 1) {
          // this.active = id
          this.$store.dispatch('productListScrollToStartPosition', id);
          this.$store.dispatch('queryProductList', { brandId: id });
        } else if (this.list && this.list[0] && this.list[0].brandId) {
          // this.active = this.list[0].brandId
          this.$store.dispatch('productListScrollToStartPosition', this.list[0].brandId);
          this.$store.dispatch('queryProductList', { brandId: this.list[0].brandId });
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.pc_scroll-tab {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  .scroll {
    height: 100%;
    overflow: hidden;
    float: left;
    text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
  }
  .activity-rule-nav {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 16px;
    cursor: pointer;
    .active {
      color: #ff8a14;
    }
    li {
      color: #282828;
      margin-right: 60px;
    }
  }
  .activity-rule-nav {
    font-size: 16px;
    // margin: 0px auto;
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .activity-rule-nav li {
    white-space: nowrap;
    text-align: center;
    display: block;
    box-sizing: border-box;
    cursor: pointer;
    // overflow: hidden;
    position: relative;
    margin-right: 60px !important;
    font-size: 16px;
  }
}
</style>
